import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { WarningComponent } from "./warning/warning.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { BsDatepickerModule } from "ngx-bootstrap";
import { SelectModule } from "ng-select";
import { AgmCoreModule } from "@agm/core";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { ImageService } from "../../../imageService";
import { FilterProductsModule } from "../../../../layout/filter-products/filter-products.module";
import { TranslateModule } from "@ngx-translate/core";
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    SelectModule,
    FilterProductsModule,
    TooltipModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyC0fgs5qkpOIDJRXBNG8mNApwwFk30qhMs",
    }),
    TranslateModule
  ],
  declarations: [WarningComponent],
  exports: [WarningComponent],
})
export class WarningModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/warning/warning.module.ts